import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/axios';
import Swal from "sweetalert2";
import Config from '../../config';
import { useJWTAuthActions } from '../../services/JWTAuthProvider';
export const LoginMain = () => {
    const [errorInp, setError] = useState('');
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const { ssoSignInUser } = useJWTAuthActions();

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (email.trim() === '') {
            setError('* Please enter a valid username or email id');
            document.getElementById('user-input').classList.add('error');
            return;
        }
        setError('');
        document.getElementById('user-input').classList.remove('error');
        if (Config.SSODOMAIN.findIndex((e) => email.toLowerCase().includes(e)) >= 0) {
            await ssoSignInUser({ email });
        } else {
            try {
                const { data } = await api.get("/auth/CheckUserId?userId=" + email);
                if (data.statusCode === 200 && data.result) {
                    navigate('/Login', { state: { username: email } });
                }
                else {
                    Swal.fire({
                        position: "center",
                        icon: "info",
                        text: "User you are trying to login, not available in the system",
                        confirmButtonText: "Ok",
                        timer: 3000,
                        timerProgressBar: true,
                    })
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    }
    const handleInputChange = (e) => {
        setEmail(e.target.value);
    }

    return (
        <div className='main1'>
            <div className='left-part2'></div>
            <div className='right-part2'>
                <div className='right-top'>
                    <img src='/Assets/logo.svg' alt='Resource Center' />
                    <h2>Login Credential</h2>
                </div>
                <form className='login-input' onSubmit={handleFormSubmit}>
                    <label className='form-label'>Username or Email ID</label>
                    <div className='input-wrap'>
                        <input
                            type='text'
                            className={`form-control user-input ${errorInp ? 'error' : ''}`}
                            value={email}
                            onChange={handleInputChange}
                            id="user-input"
                        />
                    </div>

                    {errorInp && <p className="error-message">{errorInp}</p>}

                    <div className='login-btn'>
                        <button className='btn-primary' type='submit' >
                            Sign in
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
